module.exports = __webpack_public_path__ + "img/car_00033.bb97affe.jpg";